import { render, staticRenderFns } from "./ListModality.vue?vue&type=template&id=6bec6c78"
import script from "./ListModality.vue?vue&type=script&lang=js"
export * from "./ListModality.vue?vue&type=script&lang=js"
import style0 from "./ListModality.vue?vue&type=style&index=0&id=6bec6c78&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports